<template>
  <div class="inject-home">
    <div style="margin-bottom:10px;">
      <material-select :type="1" @selected="handleSelectedSandtableImg">
        <template slot="body">
          <a-button type="primary" block>{{$t('edit.sandboxs.selectImg')}}</a-button>
        </template>
      </material-select>
    </div>

<!--    <div class="image-list" v-if="cloneSandtable.url">-->
<!--      <img :src="cloneSandtable.url" />-->
<!--      <div class="material-option">-->
<!--        &lt;!&ndash; <span class="m-title">{{currentImage.name}}</span> &ndash;&gt;-->
<!--        <span class="m-dele" @click="onClickDel">{{$t('actionTitles.delete')}}</span>-->
<!--      </div>-->
<!--    </div>-->
    <div class="select-image-box">
      <div class="image-list" v-if="imgList.length > 0 && item" v-for="(item, index) in imgList">
        <div class="image-item-box">
          <img @click="selectImgIndex(index)" :src="item" :style="selectImg === index ? 'border: 2px solid rgb(24, 144, 255);' : ''" />
        </div>
        <div class="material-option">
          <!-- <span class="m-title">{{currentImage.name}}</span> -->
          <span class="m-dele" @click="onClickDel(index)">{{$t('actionTitles.delete')}}</span>
        </div>
      </div>
    </div>


    <div style="margin:20px 0">
      <div style="margin-bottom:8px">{{$t('edit.editMessage.sceneConfirm')}}</div>
      <div class="list-container" v-if="Object.keys(canChooseScenes).length > 0">
        <ImgItem
          :itemObj="value"
          v-for="(value, k) in canChooseScenes"
          :key="k"
          :selected="selectedScene"
          @click.native="selectScene(value)"
        ></ImgItem>
      </div>
    </div>

    <SandList
      v-for="(item, index) in cloneSandtable.scenes"
      :key="index"
      :itemObj="item"
      @renameItem="renameItem"
      @deleteItem="deleteItem"
      @onSelectItem="onSelectItem"
    ></SandList>

    
    <a-button type="primary" block ghost v-if="selectedScene.length>0 && cloneSandtable.url" @click="onClickAdd">{{$t('edit.sandboxs.addToScene')}}</a-button>
    <!--重命名-->
    <a-modal
      v-model="renameVisible"
      :title="$t('actionTitles.rename')"
      :destroyOnClose="true"
      @ok="handleConfirm"
    >
      <div>
        <a-input v-model="newName" :addonBefore="$t('edit.name')" :placeholder="renameObj.scene_title"></a-input>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ImgItem from "../hotpoint/ImgItem.vue";
import SandList from "./SandList";
import MaterialSelect from "@/components/MaterialSelect";
import sandMixin from "../../../../mixins/sandMixin";

// const listType = {
//   word: "T",
//   pic: "圖",
//   video: "視",
//   audio: "音",
//   link: "鏈",
//   scene: "場",
// };

export default {
  components: {
    ImgItem,
    SandList,
    MaterialSelect,
  },
  mixins: [sandMixin],
  data() {
    return {
      // list: [
      //   { type: this.$t('edit.typeList.picture'), name: "圖片素材" },
      //   { type: "T", name: "文本素材" },
      //   { type: "視", name: "視頻素材" },
      //   { type: "圖", name: "圖片素材" },
      // ],
      allScenes: {},
      newName: "",
      renameObj: {},
      renameVisible: false,
      currentImage: {},
      selectedScene: [],
      currpoints: [],
      cloneSandtable: {},
      canChooseScenes: {},
      imgList: [],
      allSandTable:[],
      selectImg:0,
    };
  },
  computed: {
    ...mapGetters([
      "vrbase",
      "currentScenesId",
      "currentHlookat",
      "editSandtable",
      "sandTable",
      "sandTableImg",
      "imgIndex",
      "userInfo"
    ]),
  },
  watch: {
    editSandtable() {
      this.cloneSandtable = this.$deepClone(this.editSandtable);
      this.handleErrorSceneTypesByMixin();
      console.log("editSandtable====>",this.cloneSandtable)
    },
    allScenes(){
      this.setCanChooseScenes();
    },
    currpoints() {},
    // sandTableImg(){
    //   this.imgList = this.$deepClone(this.sandTableImg);
    //   console.log("sandTableImg====>",this.imgList)
    // }
    sandTable(){
      this.allSandTable = this.$deepClone(this.sandTable);
      this.setCanChooseScenes();
      this.getImg();
      console.log("sandTable====>",this.allSandTable)
    },
    imgIndex(){
      this.selectImg = this.$deepClone(this.imgIndex)
    }
  },
  created() {
    this.cloneSandtable = this.$deepClone(this.editSandtable);
    this.handleErrorSceneTypesByMixin();
    this.allScenes = this.vrbase.scenes; // 全部場景數據
    this.allSandTable = this.$deepClone(this.sandTable);
    this.selectImg = this.$deepClone(this.imgIndex)
    this.setCanChooseScenes();
    this.getImg();
  },
  methods: {
    setCanChooseScenes() {
      let canChooseScenes = {};
      let chooseScenes = [];
      for (let i = 0; i < this.allSandTable.length; i++) {
        for (const j in this.allSandTable[i].scenes) {
          chooseScenes.push(j)
        }
      }
      Object.keys(this.allScenes).forEach((key) => {
        if (chooseScenes.indexOf(key) === -1) {
          canChooseScenes[key] = this.allScenes[key];
        }
        // if (!this.cloneSandtable.scenes[key]) {
        //   // this.$set(canChooseScenes, key, this.allScenes[key]);
        //   canChooseScenes[key] = this.allScenes[key];
        // }
      });
      this.canChooseScenes = canChooseScenes;
    },
    updateSandtable() {
      // 更新cloneSandtable到store
      this.$store.commit("SET_EDIT_SANDTABLE", this.cloneSandtable);
    },
    handleListOption(value, option) {
      console.log(value, option);
    },
    selectScene(item) {
      console.log('觸發selectScene的item:',item);
      this.selectedScene = [item];
    },
    handleSelectedSandtableImg(value) {
      // 判斷圖片尺寸必須為480X480
      let img = new Image();
      img.src = value.url;
      img.onload = () => {
        //if (img.width >= 480 && img.height >= 480) {
          this.$store.commit("ADD_SANDTABLE",{url:value.url,scenes:{}});
          // this.cloneSandtable.url = value.url;
          // this.updateSandtable();
        //} else {
        //  this.$message.error(this.$t('edit.sandboxs.sizeAlert'));
        //}
      };
      img.οnerrοr = function () {
        this.$message.error(this.$t('edit.editMessage.imgeError'));
      };
    },
    //點擊選中cell
    onSelectItem(item) {
      this.$store.dispatch("loadScene", item.scene_id);
      console.log(item);
    },
    renameItem(selectedItem) {
      this.renameObj = selectedItem;
      this.renameVisible = true;
    },
    deleteItem(selectedItem) {
      this.$delete(this.cloneSandtable.scenes, selectedItem.scene_id);
      this.updateSandtable();
      this.setCanChooseScenes();
    },
    handleConfirm() {
      this.renameVisible = false;
      this.$set(
        this.cloneSandtable.scenes[this.renameObj.scene_id],
        "scene_title",
        this.newName
      );
      // reset data
      this.newName = "";
      this.renameObj = {};
      this.updateSandtable();
    },
    onClickDel(index) {
      this.$store.commit("DEL_SANDTABLE",index);
      this.$forceUpdate();
      console.log("onClickDel===>",index)
      this.selectedScene = []
      this.setCanChooseScenes()

    },
    onClickAdd() {
      if(this.selectedScene.length === 0) {
        this.$message.error(this.$t('edit.editMessage.sceneConfirm'))
        return;
      }
      if(Object.keys(this.canChooseScenes).length === 0) {
        this.$message.error(this.$t('edit.sandboxs.noSceneToAdd'))
        return;
      }
      this.$set(this.cloneSandtable.scenes, this.selectedScene[0].scene_id, {
        rotate: 0,
        hlookat: this.currentHlookat,
        top: "50%",
        left: "50%",
        kr_top: "50%",
        kr_left: "50%",
        scene_title: this.selectedScene[0].scene_title,
        scene_id: this.selectedScene[0].scene_id,
      });
      this.updateSandtable();
      this.setCanChooseScenes();
      this.$store.dispatch("loadScene", this.selectedScene[0].scene_id);
      this.selectedScene = []
    },
    // 去掉可選場景中已經選擇的場景
    handleSenceShowData(selectedSence = null, type = "") {
      if (type === "add") {
        const copyAll = this.$deepClone(this.vrbase.scenes);
        this.allScenes[selectedSence.scene_id] =
          copyAll[selectedSence.scene_id];
      } else {
        if (selectedSence) {
          // 選擇場景後要去掉
          this.$delete(this.allScenes, selectedSence.scene_id);
        } else {
          // 初次進來的時候，要過濾到掉已選的場景
          for (let pointKey in this.currpoints) {
            const pointItem = this.currpoints[pointKey];
            for (let senceKey in this.allScenes) {
              const currSence = this.allScenes[senceKey];
              if (currSence.scene_id === pointItem.scene_id) {
                this.$delete(this.allScenes, senceKey);
              }
            }
          }
        }
      }
    },
    getImg(){
      this.imgList = this.allSandTable.map((item, index) => {
        return item.url
      })
    },
    selectImgIndex(index){
      this.$store.commit("SET_SELECT_IMG_INDEX",index);
    }
  },
};
</script>

<style lang="less" scoped>
.list-container {
  display: grid;
  justify-items: center;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 5px;

  // color: #2c3e50;
}
.image-list {
  padding: 10px 4px 0;
  text-align: center;
}
.image-list img {
  //object-fit: contain;
  //width: 200px;
  width: 100%;
  height: 100%;
  border: 2px solid #FFFFFF;
}
.material-option {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 10px 20px;
  cursor: pointer;
}
.m-title {
  width: 180px;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.m-dele {
  width: 30px;
}
.select-image-box{
  display: grid;
  //justify-items: center;
  grid-template-columns: 1fr 1fr;
  grid-gap:5px
}
.image-item-box{
  width: 100%;
  height: 60px;
}
.selectBtn {
  background-color: #7101ad;
  border-color: #7101ad;
}
.selectBtn:hover {
  background-color: #c250ff;
  border-color: #c250ff;
}
.selectBtn:focus{
  background-color: #c250ff;
  border-color: #c250ff;
}
</style>